export default {
      id: "tooltip-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#tooltip",
      toString: function () {
        return this.url;
      }
    }